export default {
  ar() {
    return {
      couldNotProcess: 'نحن نأسف على عدم استكمال طلبكم. من فضلك قم بالتواصل معنا اذا استمرت المشكلة بالحدوث معك.',
      hotelNotAvailable: '',
      paymentMethod: '{number}. طريقة الدفع',
      placeOrder: 'إدراج الطلب {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'مراجعة طلبك',
      updateInfo: 'تحديث معلومات الدفع والشحن',
    }
  },
  de() {
    return {
      couldNotProcess: 'Es tut uns leid, aber wir können mit Ihrer Bestellung nicht weiterfahren. Bitte kontaktieren Sie uns, falls das Problem weiter besteht.',
      hotelNotAvailable: '',
      paymentMethod: '{number}. Zahlungsmittel',
      placeOrder: 'Bestellung aufgeben {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Ihre Bestellung überprüfen',
      updateInfo: 'Rechnungs- und Lieferinformationen aktualisieren',
    }
  },
  en() {
    return {
      couldNotProcess: 'Sorry, we could not process your order. Please contact us if the problem continues.',
      hotelNotAvailable: 'Sorry, we were unable to reserve this hotel room. Please select a new one.',
      paymentMethod: '{number}. Payment Method',
      placeOrder: 'Place Order {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Review Your Order',
      updateInfo: 'Update Billing & Shipping Information',
    }
  },
  enGB() {
    return {
      couldNotProcess: 'Sorry, we could not process your order. Please contact us if the problem continues.',
      hotelNotAvailable: 'Sorry, we were unable to reserve this hotel room. Please select a new one.',
      paymentMethod: '{number}. Payment Method',
      placeOrder: 'Place Order {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Review Your Order',
      updateInfo: 'Update Billing & Shipping Information',
    }
  },
  esMX() {
    return {
      couldNotProcess: 'Lo sentimos, no podemos procesar su orden. Favor de contactarnos si el problema continúa.',
      hotelNotAvailable: '',
      paymentMethod: '{number}. Método de Pago',
      placeOrder: 'Colocar Orden {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Revise Su Orden',
      updateInfo: 'Actualizar Información de Envío y Facturación',
    }
  },
  fr() {
    return {
      couldNotProcess: 'Désolé, nous n\'avons pas pu traiter votre commande. Si le problème persiste, veuillez nous conctacter.',
      hotelNotAvailable: '',
      paymentMethod: '{number}. Méthode de paiement',
      placeOrder: 'Passer la commande {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Vérifier Votre Commande',
      updateInfo: 'Modifier vos adresses de facturation et de livraison',
    }
  },
  it() {
    return {
      couldNotProcess: 'Ci dispiace, ma non è stato possibile elaborare il tuo ordine. Ti preghiamo di contattarci nel caso in cui il problema dovesse persistere.',
      hotelNotAvailable: '',
      paymentMethod: '{number}. Metodo di pagamento',
      placeOrder: 'Effettua Ordine {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'Controlla il tuo ordine',
      updateInfo: 'Aggiorna i dati di fatturazione e di spedizione',
    }
  },
  ja() {
    return {
      couldNotProcess: '大変申し訳ございません、ご注文を完了できませんでした。引き続き問題が発生する場合は弊社までご連絡ください。',
      hotelNotAvailable: '',
      paymentMethod: '{number}. 支払い方法',
      placeOrder: '注文する {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: '注文内容を確認する',
      updateInfo: '請求先と発送先の情報を更新',
    }
  },
  pl() {
    return {
      couldNotProcess: 'Przepraszamy, nie mogliśmy zrealizować Twojego zamówienia. Prosimy o kontakt, jeśli problem się powtórzy.',
      hotelNotAvailable: '',
      paymentMethod: '{number}. Forma płatności',
      placeOrder: 'złóż zamówienie na {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: 'sprawdź swoje zamówienie',
      updateInfo: 'Uaktualnij dane do rozliczeń i wysyłki',
    }
  },
  zhCN() {
    return {
      couldNotProcess: '抱歉，我们无法处理您的订单。如果问题持续出现请联系我们。',
      hotelNotAvailable: '',
      paymentMethod: '{number}.支付方式',
      placeOrder: '下单 {amount}',
      processing: 'Processing {amount} with card ending in {numbers}',
      reviewOrder: '查看您的订单',
      updateInfo: '更新帐单和发货信息',
    }
  }
}
